window.Dunning = {

    massActivation : function(doctype, docids){

        SellsyJS.WebServiceCaller.post('/rest/documents/'+doctype+'/dunning/mass/activation', {}, {"docids":docids}, function(result) {
            Push.success(Loc.g("Activation de la relance en cours..."))
        });

    },

    massDeactivation : function(doctype, docids){

        SellsyJS.WebServiceCaller.post('/rest/documents/'+doctype+'/dunning/mass/deactivation', {}, {"docids":docids}, function(result) {
            Push.success(Loc.g("Désactivation de la relance en cours..."))
        });
    }
};